export default function Hero() {
  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-100">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              今日热门推荐
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              悟空影视 - 免费高清影视在线观看平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mb-5 font-medium">
              海量资源 · 无需注册 · 即点即播 · 流畅不缓冲
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-7 max-w-xl mx-auto lg:mx-0">
              悟空影视致力于为广大影迷提供最新最全的免费影视资源。无论是热播电视剧、院线大片，还是经典老片、热门综艺，这里一网打尽。无需注册账号，无需安装插件，打开网页即刻畅享高清画质观影体验。平台每日更新海量内容，覆盖动作、喜剧、爱情、悬疑、科幻、古装等多种类型，满足全家人的追剧需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-7">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-video-add-line text-accent-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600">
                  <strong className="text-foreground-900">每日更新 200+</strong> 部内容
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-tv-2-line text-accent-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600">
                  <strong className="text-foreground-900">覆盖全网</strong> 热播剧集
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-4k-line text-accent-600 text-sm"></i>
                </span>
                <span className="text-sm text-foreground-600">
                  <strong className="text-foreground-900">1080P 高清</strong> 流畅不缓冲
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#ranking')}
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观看
              </button>
              <button
                onClick={() => handleScroll('#carousel')}
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-foreground-700 bg-background-50 hover:bg-background-100 border border-background-300 rounded-md transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line mr-2"></i>
                浏览专题
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] md:aspect-[16/10] lg:aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20collage%20with%20warm%20red%20and%20gold%20lighting%2C%20film%20reels%20and%20clapperboard%20floating%20in%20dramatic%20spotlight%2C%20classic%20theater%20curtains%20on%20sides%2C%20artistic%20movie%20poster%20style%20composition%2C%20rich%20cinematic%20atmosphere%20with%20deep%20shadows%2C%20professional%20film%20industry%20aesthetic%2C%20warm%20theater%20glow%2C%20clean%20and%20polished%20visual%20style&width=800&height=600&seq=hero-wukong-visual&orientation=landscape"
                alt="悟空影视 - 海量高清影视资源免费在线观看"
                className="w-full h-full object-cover"
                title="悟空影视免费高清影视在线观看平台主视觉"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-3 py-1.5 rounded-full bg-background-50/90 text-xs font-medium text-foreground-900 backdrop-blur-sm">
                  🔥 正在热播
                </span>
                <span className="px-3 py-1.5 rounded-full bg-background-50/90 text-xs font-medium text-foreground-900 backdrop-blur-sm">
                  🆕 今日更新
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}